"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BasketReducer_1 = require("../../basket/reducers/BasketReducer");
const BasketSagas_1 = tslib_1.__importDefault(require("../../basket/sagas/BasketSagas"));
const loadBasketModule = () => ({
    id: 'Basket',
    reducerMap: {
        basket: BasketReducer_1.basketReducer,
    },
    sagas: [BasketSagas_1.default],
});
exports.default = loadBasketModule;
